/**
 * Runs `callback` when the browser is idle, falling back to `setTimeout` when
 * `requestIdleCallback` isn't available (Safari). Returns a cleanup function that cancels
 * whichever was scheduled.
 */
export default function scheduleIdleCallback(callback: () => void, timeout = 2000): () => void {
  if (typeof window === 'undefined') {
    return () => {}
  }

  if (typeof window.requestIdleCallback === 'function') {
    const handle = window.requestIdleCallback(callback, { timeout })
    return () => window.cancelIdleCallback(handle)
  }

  const id = window.setTimeout(callback, timeout)
  return () => window.clearTimeout(id)
}
